import { render, staticRenderFns } from "./FormulateVFile.vue?vue&type=template&id=a405b0d8"
import script from "./FormulateVFile.vue?vue&type=script&lang=js"
export * from "./FormulateVFile.vue?vue&type=script&lang=js"
import style0 from "./FormulateVFile.vue?vue&type=style&index=0&id=a405b0d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports